import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=587d69ba&scoped=true"
import script from "./DashboardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=587d69ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d69ba",
  null
  
)

export default component.exports